import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import api from '../api';
import { Observable } from 'rxjs';
import { UserInfo } from '../../models/UserInfo.model';
import { UserGroupInfo } from '../../models/UserGroupInfo.model';

@Injectable()
export class UserService {
  constructor(public http: HttpClient) { }

  GetUsers(): Observable<Array<UserInfo>> {
    return this.http.get<Array<UserInfo>>(`${api.url}${api.Admin.GetUsers}`);
  }

  GetUserDetail(id: number): Observable<UserInfo> {
    return this.http.get<UserInfo>(`${api.url}${api.Admin.User}/${id}`);
  }

  GetUserGroups(): Observable<Array<UserGroupInfo>> {
    return this.http.get<Array<UserGroupInfo>>(`${api.url}${api.Admin.GetUserGroups}`);
  }
  
  GetUserGroupDetail(id: string): Observable<UserGroupInfo> {
    return this.http.get<UserGroupInfo>(`${api.url}${api.Admin.GetUserGroupDetail}/${id}`);
  }

  CreateGroup(data: UserGroupInfo): Observable<UserGroupInfo> {
    return this.http.post<UserGroupInfo>(`${api.url}${api.Admin.CreateGroup}`, data);
  }

  UpdateGroup(data: UserGroupInfo): Observable<boolean> {
    return this.http.put<boolean>(`${api.url}${api.Admin.UserGroup}/${data.Id}`, data);
  }

  UpdateGroups(data: Array<UserGroupInfo>): Observable<boolean> {
    return this.http.put<boolean>(`${api.url}${api.Admin.UserGroup}/${api.Admin.UpdateMulti}`, data);
  }

  DeleteGroup(id: string): Observable<boolean> {
    return this.http.delete<boolean>(`${api.url}${api.Admin.UserGroup}/${id}`);
  }
}

